<template>
  <v-dialog persistent v-model="dialog" width="320">
    <v-card>
      <v-card-title class="title"
        >Deseja apagar esse<br />
        arquivo?</v-card-title
      >
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="default" text @click="closeDialog">Não</v-btn>
        <v-btn color="secondary" text @click="saveConfirm">Sim</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogChild: {
      required: true,
      type: Boolean,
    },
  },

  data: () => ({}),

  computed: {
    dialog() {
      return this.dialogChild;
    },
  },
  methods: {
    closeDialog() {
      this.$emit('closeChild');
    },

    saveConfirm() {
      this.$emit('confirmChild');
    },
  },
};
</script>
